module.exports = __webpack_public_path__ + "static/media/right-arrow.6a6f342e.svg";